import { formatDateTime, uId } from "common/utility"
import { getConfirmOrderList, getOneOrder } from "http/order/order"
import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { formatNumberWithCommas } from '../../common/utility'
import {
  Row,
  Col,
  Container,
  Button,
  Card,
  CardBody,
  Label,
  Table,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap"
import { Tooltip } from "react-tooltip"

const ViewOrderRequest = () => {
  document.title = "Request Order Detail | DMS"
  const { id } = useParams()
  const navigate = useNavigate()
  const [order, setOrder] = useState(null)
  const [confirmOrders, setConfirmOrders] = useState([])
  const user = JSON.parse(localStorage.getItem("user"));
  const [open, setOpen] = useState("1");
  const [hasError, setHasError] = useState([]);

  const toggle = id => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  useEffect(() => {
    if (id) {
      fetchOrder()
      fetchConfirmOrder()
    }
  }, [id])

  const fetchOrder = () => {
    getOneOrder({ id: id })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          const orderData = responseFromAPI.data
          setOrder(orderData)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  const fetchConfirmOrder = () => {
    getConfirmOrderList({ requestOrderId: id })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          const orderData = responseFromAPI.data.data
          setConfirmOrders(orderData)
        } else {
          setConfirmOrders([])
        }
      })
      .catch(error => { })
  }

  const handleCancel = () => {
    navigate(-1)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col md={12} sm={12} xl={12} className="page-title-box d-flex gap-3 justify-content-between align-items-center" style={{ paddingBottom: "0" }}>
              <div className="d-flex align-items-center ">
                <h4 className="mb-sm-0 font-size-18">
                  Order Request Details
                </h4>
              </div>
              <div>
                <button
                  className="btn btn-outline-secondary ms-2"
                  type="button"
                  onClick={handleCancel}
                >
                  Back
                </button>
              </div>
            </Col>
          </Row>
          <div
            className="mt-3 mb-3 order"
            style={{ maxWidth: "1760px" }}
          >
            {order && (
              <>
                <Card>
                  <CardBody>
                    <Row>
                      <Row>

                        <Col xs="6" md="3">
                          <div>
                            <Label className="fw-bold text-0F172A">Order Request ID</Label>
                            <p className="lh-1">{order.orderCode}</p>
                          </div>
                        </Col>
                        <Col xs="6" md="3">
                          <div>
                            <h6 className="fw-bold text-0F172A">Date</h6>
                            <p className="lh-1">{formatDateTime(order.orderDate)}</p>
                          </div>
                        </Col>
                        <Col xs="6" md="3">
                          <div>
                            <h6 className="fw-bold text-0F172A">Total Amount</h6>
                            <p className="lh-1">{formatNumberWithCommas(order.totalAmount)}</p>
                          </div>
                        </Col>
                        <Col xs="6" md="3">
                          <div>
                            <h6 className="fw-bold text-0F172A">Status</h6>
                            <p
                              style={{
                                width: "55%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "5px",
                              }}
                              className={` fw-bold text-capitalize ${order.orderStatus === "pending" ||
                                order.orderStatus === "processing"
                                ? "bg-warning rounded-pill text-white px-3"
                                : order.orderStatus === "cancelled" ||
                                  order.orderStatus === "rejected"
                                  ? "bg-danger rounded-pill text-white px-3"
                                  : "bg-green rounded-pill text-white px-3"
                                } d-inline-block w-auto`}
                            >
                              {order.orderStatus}
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Col
                        md="12"

                      >
                        <Accordion flush open={open} toggle={toggle} >
                          <AccordionItem className="">
                            <AccordionHeader targetId="1" style={{ borderBottom: "1px solid #adb5bd", backgroundColor: 'white' }}>
                              <h5 style={{ fontSize: '1rem', color: '#73778c' }}>
                                Product Details
                              </h5>
                            </AccordionHeader>
                            <AccordionBody accordionId="1">
                              <div style={{ display: "flex", flexDirection: 'column' }}>
                                <table className="" style={{ backgroundColor: 'white', width: '100%' }}>
                                  <thead style={{ backgroundColor: '#f8f8fb', color: '#495057' }}>
                                    <tr>
                                      <th style={{ padding: '1rem 10px' }}>Product Image</th>
                                      <th style={{ padding: '1rem 10px' }}>Product Name</th>
                                      <th style={{ padding: '1rem 10px' }}>Requested Qty</th>
                                      <th style={{ padding: '1rem 10px' }}>Remaining Qty</th>
                                      <th style={{ padding: '1rem 10px' }}>Price</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {order?.products?.map((productItem, index) => {
                                      let imgUrl = productItem?.product?.productImages?.find(
                                        imgItem => imgItem?.image?.primary
                                      );
                                      return (
                                        <tr key={uId()} style={{ backgroundColor: 'white', borderBottom: '1px solid #ddd' }}>
                                          <td
                                            style={{
                                              padding: "0.5rem 0",
                                              marginBottom: "15px",
                                              paddingLeft: '0.6rem'
                                            }}
                                          >
                                            <div className={(imgUrl?.image?.paths?.original && !hasError[index]) ? "td-product-img" : "td-no-product-img"}>
                                              {
                                                (imgUrl?.image?.paths?.original && !hasError[index]) ? (
                                                  <img
                                                    src={
                                                      process.env.REACT_APP_IMAGE_URL +
                                                      imgUrl?.image?.paths?.original
                                                    }
                                                    alt=""
                                                    style={{
                                                      cursor: "pointer",
                                                      width: '100%',
                                                      height: '4.5rem'

                                                    }}
                                                    onError={(e) => {
                                                      e.target.onerror = null; 
                                                      e.target.src = '/no-image.png';
                                                      e.target.style.width = '2.5rem';
                                                      e.target.style.height = '2.5rem';
                                                      setHasError(prevState => {
                                                        const newState = [...prevState];
                                                        newState[index] = true;
                                                        return newState;
                                                      });
                                                    }}
                                                    className="img-fluid d-block"
                                                  />
                                                ) : (
                                                  <img
                                                    src={
                                                      "/no-image.png"
                                                    }
                                                    alt=""
                                                    className="img-fluid mx-auto d-block"
                                                    style={{

                                                      cursor: "pointer",
                                                      width: '2rem'
                                                    }}
                                                  />
                                                )
                                              }
                                            </div>
                                          </td>
                                          <td style={{ padding: '0.5rem 0', marginBottom: '15px' }}>
                                            <div style={{ marginLeft: '10px' }}>
                                              <h5 className="text-truncate font-size-14">
                                                {productItem?.product?.productName}
                                              </h5>
                                            </div>
                                          </td>
                                          <td style={{ padding: '0.5rem 0', marginBottom: '15px' }}>
                                            <div style={{ marginLeft: '10px' }}>{productItem?.quantity}</div></td>
                                          <td style={{ padding: '0.5rem 0', marginBottom: '15px' }}>
                                            <div style={{ marginLeft: '10px' }}>
                                              {(order.orderStatus === "rejected" ||
                                                order.orderStatus === "cancelled") ? productItem?.quantity : productItem?.remainingQuantity}
                                            </div>
                                          </td>
                                          <td style={{ padding: '0.5rem 0', marginBottom: '15px' }}>
                                            <div style={{ marginLeft: '10px' }}>
                                              {formatNumberWithCommas(productItem.product?.sellingPrice *
                                                productItem.quantity)}
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </AccordionBody>
                          </AccordionItem>
                        </Accordion>

                      </Col>
                      <div className="d-flex gap-3">
                        {(order.orderStatus === "rejected" ||
                          order.orderStatus === "cancelled") &&
                          order?.remarks && (
                            <div className="mb-3 d-flex gap-1">
                              <Label
                                className="form-label"
                                style={{ fontWeight: 600 }}
                              >
                                Remarks:
                              </Label>
                              <p data-tooltip-id="remarks-tooltip">
                                {order?.remarks?.length > 50
                                  ? `${order.remarks?.substring(0, 50)}...`
                                  : order.remarks || "NA"}
                              </p>
                              <Tooltip
                                style={{ maxWidth: "500px", marginLeft: "1rem" }}
                                id={`remarks-tooltip`}
                                place="top"
                                content={order?.remarks}
                              />
                            </div>
                          )}
                      </div>
                      <Col xs="12" md="6" >
                        <div className="bottom-4 pt-3 bg-white">
                          {confirmOrders?.length > 0 && (
                            <button
                              className="btn btn-outline-success  fw-bold me-2"
                              onClick={() => {
                                navigate(`/customer/orders?orderCode=${order.orderCode}`)
                              }}
                            >
                              View Orders ({confirmOrders?.length || 0})
                            </button>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </>
            )}
          </div>
        </Container>
      </div >
    </React.Fragment >
  )
}

export default ViewOrderRequest